/* eslint-disable max-lines*/
'use strict';
/* eslint-disable complexity*/
/* eslint-disable vars-on-top*/
/* Extend the string object to have some usefull helper function for use with
   twitter messages */
/* eslint-disable no-implicit-globals*/
/* eslint-disable no-underscore-dangle*/
/* eslint-disable id-match*/
/* eslint-disable id-length*/
/* eslint-disable init-declarations*/
/* eslint-disable camelcase*/
/* eslint-disable no-unused-vars*/
/* eslint-disable xss/no-mixed-html*/
/* eslint-disable max-statements*/

var _PE;

/* eslint-enable init-declarations*/
/* eslint-enable no-underscore-dangle*/
/* eslint-enable no-implicit-globals*/
/* eslint-disable no-extend-native */
String.prototype.parseURL = function() {
/* eslint-disable no-useless-escape */
  return this.replace(/[A-Za-z]+:\/\/[A-Za-z0-9-_]+\.[A-Za-z0-9-_:%&~\?\/.=]+/g, function(url) {
    return '<a href="' + url + '" target="_blank">' + url + '</a>';
    /* eslint-enable no-useless-escape */
  });
};
String.prototype.parseUsername = function() {
  return this.replace(/[@]+[A-Za-z0-9-_]+/g, function(u) {
    var username = u.replace('@', '');

    return '<a href="http://twitter.com/' + username + '" target="_blank">' + u + '</a>';
  });
};
String.prototype.parseHashtag = function() {
  /* eslint-enable no-extend-native */
  return this.replace(/[#]+[A-Za-z0-9-_]+/g, function(t) {
    var tag = t.replace('#', '%23');

    return '<a href="http://search.twitter.com/search?q' + tag + '" target="_blank">' + t + '</a>';
  });
};
/* End of string object extension */

_PE.modules.firstLast = {
  id: 'firstLast',
  PEClass: 'dl, ul, ol, .firstlast',

  init: function() {
    this.elements.each(function() {
      /* eslint-disable no-invalid-this */
      var $this = $(this);

      $this.children(':first').addClass('first');
      $this.children(':last').addClass('last');
    });
  }
};

_PE.modules.homepageTopSlider = {
  id: 'homepageTopSlider',
  PEClass: '.pe_homepage_top_slider',

  idx: 1,
  interval: null,

  init: function() {
    var breakout = this.elements.find('.breakout'),
        images = breakout.find('figure'),
        $articleBreakout = $('.article-breakout'),
        speed = 6,
        /* eslint-disable consistent-this*/
        self = this;

    if (images.length <= 1) {
      breakout.addClass('ph-breakoutwidth');
    } else {
      breakout.removeClass('ph-breakoutwidth');
    }

    /* eslint-disable  no-mixed-operators */
    if (images.length > 1) {
      self.startSlider(speed, breakout, images, $articleBreakout);
    }

    $(window).on('resize', function() {
      self.idx = 1;

      if (images.length > 1) {
        self.startSlider(speed, breakout, images, $articleBreakout);
      }
    });
  },
  startSlider: function(speed, breakout, images, articleBreakout) {
    /* eslint-enable consistent-this*/
    var screenWidth = $(window).width();

    images.css({
      width: screenWidth + 'px'
    });
    breakout.css({
      marginLeft: 0
    });
    articleBreakout.css({
      marginLeft: 0
    });
    breakout.width(screenWidth * images.length + 100);
    articleBreakout.width(965 * images.length);
    this.makeThumbs(images.length, speed);
    this.sliding(speed * 1000, breakout, screenWidth, images, articleBreakout);
  },
  /* eslint-disable max-params*/
  sliding: function(wait, breakout, screenWidth, images, articleBreakout) {
    /* eslint-enable max-params*/
    /* eslint-disable consistent-this*/
    var self = this;


    clearTimeout(self.interval);
    self.interval = setTimeout(function() {
      self.nextImage(breakout, screenWidth, images, articleBreakout);
      self.sliding(wait, breakout, screenWidth, images, articleBreakout);
    }, wait);
  },

  makeThumbs: function(l, speed) {
    var container = this.elements.find('.thumbs'),
        self = this;

    container.empty();

    for (var i = 0; i < l; i = i + 1) {
      container.append('<div class="normal-thumb"></div>');
      /* eslint-disable max-len*/
      container.append('<div class="clock-thumb-container" data-index="' + i + '"><div class="thumb bg-1"></div><div class="thumb bg-2"></div><div class="top-1-container"><div class="thumb top-1"></div></div><div class="top-2-container"><div class="thumb top-2"></div></div></div>');
      /* eslint-enable max-len*/
    }

    var $thumb = $('.normal-thumb'),
        $bigThumb = $('.clock-thumb-container'),
        top1 = this.elements.find('.top-1-container'),
        top2 = this.elements.find('.top-2-container');

    top1.css('animation-duration', speed + 's', '-webkit-animation-duration', speed + 's');
    top2.css('animation-duration', speed + 's', '-webkit-animation-duration', speed + 's');

    $bigThumb.filter(':eq(' + 0 + ')').addClass('show').find('.top-1-container, .top-2-container').addClass('active');
    $bigThumb.on('click', function() {
      var data = $(this).data('index');

      clearTimeout(self.interval);
      $bigThumb.removeClass('show');
      $thumb.removeClass('big');
      $thumb.filter(':eq(' + data + ')').addClass('big');
      self.showImage(data);
    });
    container.css({
      marginLeft: '-' + (container.width() / 2) + 'px'
    });
  },

  nextImage: function(breakout, screenWidth, images, articleBreakout) {
    var marginL = screenWidth * this.idx,
        articleL = 965 * this.idx,
        length = images.length,
        bigThumb = this.elements.find('.clock-thumb-container'),
        self = this;

    bigThumb.removeClass('show').find('.top-1-container, .top-2-container').removeClass('active');
    bigThumb.filter(':eq(' + self.idx + ')').addClass('show').find('.top-1-container, .top-2-container').addClass('active');

    /* eslint-disable no-plusplus */
    if (++self.idx === length) {
      self.idx = 0;
    }

    breakout.css({
      marginLeft: '-' + marginL + 'px'
    });
    articleBreakout.css({
      marginLeft: '-' + articleL + 'px'
    });
  },

  showImage: function(data) {
    var $breakout = $('.breakout'),
        $articleBreakout = $('.article-breakout'),
        screenWidth = $(window).width(),
        mLeft = screenWidth * data,
        articleL = 965 * data;

    $breakout.css({
      marginLeft: '-' + mLeft + 'px'
    });
    $articleBreakout.css({
      marginLeft: '-' + articleL + 'px'
    });
  }
};


_PE.modules.validate = {
  id: 'validate',
  PEClass: '.pe_validate',

  inputs: null,
  feedback: null,

  init: function() {
    this.setup();
    this.bindEvents();
  },

  setup: function() {
    this.inputs = this.elements.find('input, textarea, select');
    this.feedback = this.elements.find('.feedback');

    this.feedback.slideUp(0);

    var self = this;

    /* eslint-disable consistent-return*/
    this.inputs.each(function(idx, elmnt) {
      var $src = $(elmnt);

      /* eslint-enable consistent-return*/
      $src.data('valid', false);

      if (!$src.val() || $src.is('select')) {
        return true;
      }

      /* eslint-disable no-negated-condition */
      if (!self.validate($src)) {
        $src.parents('span.input, span.textarea, span.select, span.radios, span.file').removeClass('valid').addClass('error');
        $src.data('valid', false);
      } else {
        $src.parents('span.input, span.textarea, span.select, span.radios, span.file').removeClass('error').addClass('valid');
        $src.data('valid', true);
      }
    });
  },

  bindEvents: function() {
    var self = this;

    this.inputs.on('focus blur keyup change', function(e) {
      var $src = $(e.target);

      if (!self.validate($src)) {
        $src.parents('span.input, span.textarea, span.select, span.radios, span.file').removeClass('valid').addClass('error');
      } else {
        $src.parents('span.input, span.textarea, span.select, span.radios, span.file').removeClass('error').addClass('valid');
      }
    });
    this.elements.each(function() {
      var $ins = $(this);

      $ins.on('submit', function(e) {
        var $src = $(e.target);

        var inputs = $src.find('input, textarea, select'),
            isValid = true;

        inputs.each(function(idx, elm) {
          var $srce = $(elm);

          if (!self.validate($srce)) {
            $srce.parents('span.input, span.textarea, span.select, span.radios, span.file').removeClass('valid').addClass('error');
            $srce.data('valid', false);
          } else {
            $srce.parents('span.input, span.textarea, span.select, span.radios, span.file').removeClass('error').addClass('valid');
            $srce.data('valid', true);
          }
        });

        inputs.each(function(idx, elm) {
          if (!$(elm).data('valid')) {
            isValid = false;
            /* eslint-enable no-negated-condition */
            /* eslint-disable max-len */
            $(elm).parents('span.input, span.textarea, span.select, span.radios, span.file').addClass('wrong').find('.feedback').slideDown(350).addClass('active');
          } else {
            $(elm).parents('span.input, span.textarea, span.select, span.radios, span.file').removeClass('wrong').find('.feedback').slideUp(350).removeClass('active');
            /* eslint-enable max-len */
          }
        });

        $('html,body').animate({
          scrollTop: $('.wrong').first().offset().top - 200
        }, 500);

        if (!isValid) {
          e.preventDefault();
        }

        $ins.data('valid', isValid);

        return isValid;
      });
    });
  },

  validate: function(elm) {
    var validation = elm.data('validate');

    if (!validation) {
      return true;
    }

    var required = validation.req,
        type = validation.type,
        nullval = validation.nullval;

    if (elm.attr('type') === 'radio') {
      var related = this.inputs.filter('[name="' + elm.attr('name') + '"]');

      /* eslint-disable unicorn/explicit-length-check*/
      if (required && !related.filter(':checked').length) {
        return false;
      }
      // Required
      /* eslint-enable unicorn/explicit-length-check*/
      // But
      /* No Radio In The Group Checked */
    } else {
      switch (type) {
          case 'mail':
            /* eslint-disable security/detect-unsafe-regex*/
            /* eslint-disable no-useless-escape */
            /* eslint-disable max-len */
            var vala = $.trim(elm.val()),
                rea = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            /* eslint-enable max-len */
            /* eslint-enable no-useless-escape */
            /* eslint-enable security/detect-unsafe-regex*/
            if (!rea.test(vala) && required) {
              return false;
              // Required
            } else if (vala && !rea.test(vala)) {
              return false;
            }

            // Filled,
            /* But not Required */
            break;

          case 'phone':
            var valb = $.trim(elm.val()),
                reb = /^[0-9\s-]+$/;

            if (!reb.test(valb) && required) {
              return false;
              // Required
            } else if (valb && !reb.test(valb)) {
              return false;
            }

            // Filled,
            /* But not Required */
            break;

          case 'num':
          case 'numeric':
            var valc = $.trim(elm.val()),
                rec = /^\d+$/;

            if (!rec.test(valc) && required) {
              return false;
            } else if (valc && !rec.test(valc)) {
              return false;
            }

            break;

          case 'nonull':
          default:
            var val = $.trim(elm.val());

            if (elm.data('value') && val === elm.data('value')) {
              return false;
            }

            if (((nullval && val === nullval) || !val) && required) {
              return false;
            }
            // Required

            break;
      }
    }

    return true;
  }
};

_PE.modules.checkbox = {
  id: 'checkbox',
  PEClass: '.pe_checkbox',
  checkboxes: [],

  init: function() {
    var self = this;

    this.elements.each(function(idx, checkbox) {
      self.createDOM($(checkbox));
      self.setValueFeedback($(checkbox).data('rel'), $(checkbox).is(':checked'));
    });
    /* eslint-disable dollar-sign/dollar-sign*/
    this.checkboxes = $(this.checkboxes);
    /* eslint-enable dollar-sign/dollar-sign*/
    this.bindEvents();
  },

  createDOM: function(checkbox) {
    // Wrap the checkbox element in a new element
    var $wrap = $('<div class="checkbox"></div>');

    checkbox.after($wrap);
    $wrap.append(checkbox);
    $wrap.addClass(checkbox[0].className);
    $wrap.data('rel', checkbox);
    checkbox.data('rel', $wrap);

    this.checkboxes.push($wrap[0]);
  },

  setValueFeedback: function(checkbox, checked) {
    if (checked) {
      checkbox.addClass('checked');
    } else {
      checkbox.removeClass('checked');
    }
  },

  bindEvents: function() {
    var self = this;

    this.checkboxes.on('change', function(e) {
      var $src = $(e.currentTarget),
          $trueSrc = $(e.target);

      if ($trueSrc.is(':checked')) {
        self.setValueFeedback($src, 1);
      } else {
        self.setValueFeedback($src, 0);
      }
    });
  }
};


_PE.modules.tabbar = {
  id: 'tabbar',
  PEClass: '.pe_tabbar',

  init: function() {
    var items = this.elements.find('li'),
        item_w = 100 / items.length;

    items.css({
      width: item_w + '%'
    });
  }
};

// //////////////////////////////////////////////////////////

_PE.modules.dropdown = {
  id: 'dropdown',
  PEClass: '.pe_dropdown',

  init: function() {
    var items = this.elements.find('li:not(.first)');

    $('.pe_dropdown').click(function(e) {
      e.stopPropagation();

      var $target = $(e.target);

      if ($target.hasClass('first')) {
        $('.pe_dropdown').toggleClass('open').not(this).removeClass('open');
      } else {
        $('.pe_dropdown').removeClass('open').not(this).removeClass('open');
      }
    });

    $('.calender-icon-month').click(function(e) {
      e.stopPropagation();

      $('.pe_dropdown.month').toggleClass('open');
    });
    $('.calender-icon-years').click(function(e) {
      e.stopPropagation();

      $('.pe_dropdown.years').toggleClass('open');
    });
    items.click(function() {
      var parentUl = $(this).closest('ul');

      parentUl.find('li').first().html($(this).text() + '<i></i>');
      parentUl.removeClass('open');
    });

    $('body').click(function() {
      $('.pe_dropdown').removeClass('open');
    });
  }
};

_PE.modules.shoppingCart = {
  id: 'shoppingCart',
  PEClass: '.pe_shopping_cart',


  init: function() {
    this.setup();
    this.bindEvents();
  },

  setup: function() {
    // As of now this block is empty
  },

  bindEvents: function() {
    this.deleteRow();
    this.errorMessage();
  },

  deleteRow: function() {
    var deleteBtn = this.elements.find('.icon.delete');

    deleteBtn.click(function() {
      $(this).parents('.shopping-row').remove('3000');
    });
  }
};

$('#search').keyup(function() {
  $('#search').css('color', 'black');
});

_PE.modules.quickOrder = {
  id: 'quickOrder',
  PEClass: '.pe_quickorder',
  lastItem: null,
  deletedRows: 1,
  count: 0,
  stockInfoCls: '.ph-stockinfo',
  quickorderRowCls: '.ph-quickorders__rows',
  prodqty: '.product-quantity',

  init: function() {
    var deleteBtn = this.elements.find('.ph-img-trashbin'),
        addRowBtn = this.elements.find('.addRow'),
        addCart = this.elements.find('.quickorder-rowcount'),
        self = this;

    this.lastItem = this.elements.find('.ph-quickorders__rows:not(.dummy):last');

    deleteBtn.click(function() {
      var prodquickrow = '.ph-quickorders';

      $(this).closest(prodquickrow + '__rows').remove();
      ++self.deletedRows;
      self.enableDisableCartButton('');
    });

    addRowBtn.click(function() {
      self.addARow();
    });

    addCart.click(function(event) {
      self.countRows(event);
    });

    self.handleLastItem();
    /* Commenting due to duplicate event in line no 1662
    $(document).on('change', '.product-code', function() {
      var qty = $(this).parent().next().find(_PE.modules.quickOrder.prodqty).val(),
          index = $(this).attr('tabindex'),
          prodCode = $(this).val(),
          prodinvald = 'ph-invalid-resp-messg',
          prodrow = 'ph-quickorders__rows',
          quickorderqtyplace = 'quickorders__qtyplaceholder';

      if (prodCode !== '') {
        var $rowEl = $(this).parents('.' + prodrow);

        $rowEl.find('.' + prodinvald).addClass('hidden');

        self.getQuickOrderResponse(prodCode, qty, index, function(result) {
          _PE.modules.quickOrder.handleQuickOrderResponse(result, $rowEl);
        });
        $rowEl.find('.ph-' + quickorderqtyplace).removeClass('ph-invalidproductdiv');
        $rowEl.find('.ph-prodqtyinvalid').removeClass('ph-wrongprod');
      }
    });
    */
    $(document).on('change', _PE.modules.quickOrder.prodqty, function() {
      var prodCode = $(this).parent().prev().find('.product-code').val();
      var index = $(this).attr('tabindex');
      var qty = $(this).val();
      var invalidMsg = 'invalid-resp-messg';
      var prodrow = 'quickorders__rows';

      if (qty !== '') {
        var $rowEl = $(this).parents('.ph-' + prodrow);

        $rowEl.find('.ph-' + invalidMsg).addClass('hidden');

        self.getQuickOrderResponse(prodCode, qty, index, function(result) {
          _PE.modules.quickOrder.handleQuickOrderResponse(result, $rowEl);
        });
      }
    });

    $(document).on('keyup', _PE.modules.quickOrder.prodqty, function() {
      /* Commenting to avoid redundant code to show popup and disable add to cart button
      var backorder = $('#nobackorderset').val();

      if (backorder === 'true') {
        var parentrow = '.ph-quickorders',
            quantityvar = '-quickorder__quantity',
            $rowEl = $(this).parents(parentrow + '__rows'),
            $backordpopobj = $rowEl.find(_PE.modules.quickOrder.stockInfoCls),
            maxstockVal = parseInt($rowEl.find('.ph' + quantityvar).attr('data-maxavailqty'), 10),
            enteredVal = $(this).val(),
            qtyErrorVisible = $rowEl.find('.ph-qtyerrmsg-parent:visible'),
            availSts = 'availstatus';

        if (enteredVal > maxstockVal && $(this).attr('data-' + availSts) !== 'red' && qtyErrorVisible.length === 0) {
          _PE.modules.quickOrder.enableDisableMaxqtyPopup($backordpopobj, 1, $(this).attr('data-' + availSts));
        } else {
          _PE.modules.quickOrder.enableDisableMaxqtyPopup($backordpopobj, 0, $(this).attr('data-' + availSts));
        }

        _PE.modules.quickOrder.enableDisableCartButton($(this).attr('data-' + availSts));
      }
      */
      _PE.modules.quickOrder.checkAndDisplayAllMaxQtyErrorPopup($(this).closest('.ph-quickorders__rows'));
    });

    $('.ph-quickorderdownload').click(function() {
      setTimeout(function() {
        $('.ph-quickorderdownload').removeClass('ph-disable-button');
      }, 1000);
    });

    self.loadPriceAndAvailability();
    self.enableDisableCartButton('');
  },

  showQuickOrderTitle: function($qoForm, isAtpAvailable) {
    var lineBlk = 'line-block';

    if (isAtpAvailable === true) {
      $qoForm.find('#availHead').css('display', 'in' + lineBlk);
    }

    $qoForm.find('#ph-productname').css('display', 'in' + lineBlk);
  },
  setFreeMarketingProduct: function(productCode, isFreeMarketingProduct) {
    $('#ph-qo-prod-' + productCode).attr('data-is-free-marketing-product', isFreeMarketingProduct);
  },
  loadQuickOrderProductPrice: function(prodCodes) {
    var self = this;

    for (var i = 0; i < prodCodes.length; i++) {
      var $rowEl = $('#quickOrders').find('#ph-qo-prod-' + prodCodes[i]);

      $rowEl.find('.ph-quick-loader').removeClass('hidden');
    }

    PHI.common.getPriceData(prodCodes, function(result) {
      var isAtpAvailable = $('.ph-atp-enabled').length > 0;

      if (Array.isArray(result)) {
        for (var j = 0; j < result.length; j++) {
          var $OnloadrowEl = $('#quickOrders').find('#ph-qo-prod-' + result[j].code);

          _PE.modules.quickOrder.priceDataInitialize($OnloadrowEl, result[j]);
        }
      }

      if (isAtpAvailable === true) {
        _PE.modules.quickOrder.loadQuickOrderProductAvailability(prodCodes);
      }
    });
  },

  getMaxQtyObjByCode: function(maxQtyResult, prodCode) {
    if (maxQtyResult.productMaxQtyDatas && prodCode) {
      return maxQtyResult.productMaxQtyDatas.filter(function(obj) {
        return obj.productCode === prodCode;
      });
    }

    return '';
    /* Commenting as no null check and it is similar to above code
    return maxQtyResult.filter(function(obj) {
      return obj.productCode === prodCode;
    });
    */
  },

  getUnavailableProducts: function(result) {
    if (result && result.productMaxQtyDatas !== null) {
      return result.productMaxQtyDatas.filter(function(obj) {
        return obj.showError === true;
      });
    }

    return [];
  },

  isMaxQtyProductsError: function(result) {
    var isHasError = false;

    if (result.productMaxQtyDatas !== null) {
      for (var i = 0; i < result.productMaxQtyDatas.length; i++) {
        if (result.productMaxQtyDatas[i].showError === true) {
          isHasError = true;

          break;
        }
      }
    }

    return isHasError;
  },
  addEventOnProductWithError: function(result) {
    $('.ph-img-trashbin').on('click', function() {
      if ($('[id^="ph-qo-prod-"]').length === 0) {
        $('.ph-quick-order-button').addClass('ph-disable-button');
      }
    });

    for (var i = 0; i < result.productMaxQtyDatas.length; i++) {
      var currentCode = result.productMaxQtyDatas[i].productCode;

      if (result.productMaxQtyDatas[i].showError === true) {
        $('#ph-qo-prod-' + currentCode).find('.ph-img-trashbin').on('click', function() {
          if ($('.ph-annualMaxQtyMsg').not(':hidden').length === 0 && $('[id^="ph-qo-prod-"]').length >= 1) {
            $('.ph-quick-order-button').removeClass('ph-disable-button').addClass('ph-orangebutton');
          }
        });
      }
    }
  },
  // eslint-disable-next-line max-params, max-len
  showProductLowStockMaxQtyPopup: function(backorderreload, maxQtyEnabled, product, enteredVal, lowStockQty, maxQty, totalOrdered, isFreeMarketingProduct, freeMarketingProductMaxQty) {
    var enableBtnCls = 'ph-orangebutton',
        noAvailMsg = '.ph-not-avail-msg:visible',
        addtoCartBtnCls = '.ph-quick-order-button',
        disableBtnCls = 'ph-disable-button',
        maxQtyText = '',
        maxErrPopupShown = false;

    $('#ph-qo-prod-' + product).find('.ph-maxQuantityMsg').addClass('hidden');
    $('#ph-qo-prod-' + product).find('.ph-lowStockPopup').addClass('hidden');
    $('#ph-qo-prod-' + product).find('.ph-freeMarketingMaxQuantityMsg').addClass('hidden');

    // eslint-disable-next-line max-len
    maxQtyText = ACC.common.getLowestMaxQtyValue(backorderreload, maxQtyEnabled, enteredVal, lowStockQty, maxQty, totalOrdered, isFreeMarketingProduct, freeMarketingProductMaxQty);

    if (maxQtyText === 'lowStock') {
      var currentPopupElMaxQtyBO = $('#ph-qo-prod-' + product).find('.ph-lowStockPopup'),
          popupTextMaxQty = currentPopupElMaxQtyBO.html();

      currentPopupElMaxQtyBO.removeClass('hidden');

      $('#ph-qo-prod-' + product).find('.ph-leftover-avail-msg').addClass('hidden');

      if (popupTextMaxQty.indexOf('{0}') >= 0) {
        currentPopupElMaxQtyBO.html(currentPopupElMaxQtyBO.html().replace('{0}', lowStockQty));
      } else {
        currentPopupElMaxQtyBO.html(currentPopupElMaxQtyBO.html().replace(/\d+/g, lowStockQty));
      }

      maxErrPopupShown = true;
    } else if (maxQtyText === 'maxQty') {
      var currentPopupElLowStockQtyBO = $('#ph-qo-prod-' + product).find('.ph-maxQuantityMsg'),
          popupTextLowStockQtyBO = currentPopupElLowStockQtyBO.html();

      currentPopupElLowStockQtyBO.removeClass('hidden');

      if (popupTextLowStockQtyBO.indexOf('{0}') >= 0) {
        currentPopupElLowStockQtyBO.html(currentPopupElLowStockQtyBO.html().replace('{0}', maxQty - totalOrdered));
      } else {
        currentPopupElLowStockQtyBO.html(currentPopupElLowStockQtyBO.html().replace(/\d+/g, maxQty - totalOrdered));
      }

      maxErrPopupShown = true;
    } else if (maxQtyText === 'freeMarketingMaxQty') {
      var currentPopupElMarkMatMaxQtyBO = $('#ph-qo-prod-' + product).find('.ph-freeMarketingMaxQuantityMsg');

      currentPopupElMarkMatMaxQtyBO.removeClass('hidden');
      currentPopupElMarkMatMaxQtyBO.find('.ph-free-max-qty-value').text(freeMarketingProductMaxQty);

      maxErrPopupShown = true;
    }

    if (maxErrPopupShown) {
      $('#ph-qo-prod-' + product).find('.ph-quickorders__qtyplaceholder').addClass('ph-qty-nostock');
      $('.ph-quick-order-button').addClass('ph-disable-button');
    } else {
      $('#ph-qo-prod-' + product).find('.ph-quickorders__qtyplaceholder').removeClass('ph-qty-nostock');
      $('.ph-quick-order-button').removeClass('ph-disable-button');
    }
  },
  checkAndDisplayAllMaxQtyErrorPopup: function($prodRow) {
    /* eslint-disable no-ternary, no-undefined */
    var prodCode = $($prodRow).find('.product-code').val(),
        prodAtpData = ACC.common.getAtpDataFromGlobalVar(prodCode),
        maxQtyData = ACC.common.getMaxQtyDataFromGlobalVar(prodCode),
        prodMaxQtyData = maxQtyData,
        noBackorderToggle = $('#nobackorderset').val(),
        maxQtyEnabled = $('#ph-maxQtyEnabled').val(),
        dchainProdToggle = $('.ph-dchain-product-toggle').val(),
        lowStockQty = prodAtpData.atpData.lowStockQty,
        maxQty = prodMaxQtyData.maxQtyToOrder === undefined ? -1 : prodMaxQtyData.maxQtyToOrder,
        totalOrdered = prodMaxQtyData.totalOrdered === undefined ? -1 : prodMaxQtyData.totalOrdered,
        freeMarketingProductMaxQty = prodMaxQtyData.maxMarketingMatQtyToOrder === undefined ? -1 : prodMaxQtyData.maxMarketingMatQtyToOrder,
        dChainValue = prodAtpData.dchainValue,
        dChainFirstEntry = ACC.common.getDChainFirstEntry(prodAtpData),
        // eslint-disable-next-line no-negated-condition
        dChainFirstEntryDate = dChainFirstEntry !== null ? Object.keys(dChainFirstEntry)[0] : '',
        // eslint-disable-next-line  compat/compat, no-negated-condition
        dChainFirstEntryQty = dChainFirstEntry !== null ? Object.values(dChainFirstEntry)[0] : '',
        enteredQty = $prodRow.find('.ph-quickorder__quantity').val(),
        maxQtyText = '',
        maxErrPopupShown = false,
        isCartBtnDisabled = false;

    var maxQtyReqParams = {
      nobackorderprod: noBackorderToggle,
      maxQtyEnabled: maxQtyEnabled,
      enteredQty: enteredQty,
      lowStockQty: prodAtpData.atpData.lowStockQty,
      maxQty: prodMaxQtyData.maxQtyToOrder === undefined ? -1 : prodMaxQtyData.maxQtyToOrder,
      totalOrdered: prodMaxQtyData.totalOrdered === undefined ? -1 : prodMaxQtyData.totalOrdered,
      isFreeMarketingProduct: prodMaxQtyData.isFreeMarketingMaterial === undefined ? false : prodMaxQtyData.isFreeMarketingMaterial,
      freeMarketingMaxQty: prodMaxQtyData.maxMarketingMatQtyToOrder === undefined ? -1 : prodMaxQtyData.maxMarketingMatQtyToOrder,
      dChainProductToggle: dchainProdToggle,
      dChainProductValue: dChainValue,
      dChainProductFirstEntryDate: dChainFirstEntryDate,
      dChainProductFirstEntryQty: dChainFirstEntryQty
    };
    /* eslint-enable no-ternary, no-undefined */

    $('#ph-qo-prod-' + prodCode).find('.ph-maxQuantityMsg').addClass('hidden');
    $('#ph-qo-prod-' + prodCode).find('.ph-lowStockPopup').addClass('hidden');
    $('#ph-qo-prod-' + prodCode).find('.ph-freeMarketingMaxQuantityMsg').addClass('hidden');
    $('#ph-qo-prod-' + prodCode).find('.ph-dChainMaxQuantityMsg').addClass('hidden');

    maxQtyText = ACC.common.checkAllMaxQtyValidation(maxQtyReqParams);

    if (maxQtyText === 'lowStock') {
      var currentPopupElMaxQtyBO = $('#ph-qo-prod-' + prodCode).find('.ph-lowStockPopup'),
          popupTextMaxQty = currentPopupElMaxQtyBO.html();

      currentPopupElMaxQtyBO.removeClass('hidden');

      $('#ph-qo-prod-' + prodCode).find('.ph-leftover-avail-msg').addClass('hidden');

      if (popupTextMaxQty.indexOf('{0}') >= 0) {
        currentPopupElMaxQtyBO.html(currentPopupElMaxQtyBO.html().replace('{0}', lowStockQty));
      } else {
        currentPopupElMaxQtyBO.html(currentPopupElMaxQtyBO.html().replace(/\d+/g, lowStockQty));
      }

      maxErrPopupShown = true;
    } else if (maxQtyText === 'maxQty') {
      var currentPopupElLowStockQtyBO = $('#ph-qo-prod-' + prodCode).find('.ph-maxQuantityMsg'),
          popupTextLowStockQtyBO = currentPopupElLowStockQtyBO.html();

      currentPopupElLowStockQtyBO.removeClass('hidden');

      if (popupTextLowStockQtyBO.indexOf('{0}') >= 0) {
        currentPopupElLowStockQtyBO.html(currentPopupElLowStockQtyBO.html().replace('{0}', maxQty - totalOrdered));
      } else {
        currentPopupElLowStockQtyBO.html(currentPopupElLowStockQtyBO.html().replace(/\d+/g, maxQty - totalOrdered));
      }

      maxErrPopupShown = true;
    } else if (maxQtyText === 'freeMarketingMaxQty') {
      var currentPopupElMarkMatMaxQtyBO = $('#ph-qo-prod-' + prodCode).find('.ph-freeMarketingMaxQuantityMsg');

      currentPopupElMarkMatMaxQtyBO.removeClass('hidden');
      currentPopupElMarkMatMaxQtyBO.find('.ph-free-max-qty-value').text(freeMarketingProductMaxQty);

      maxErrPopupShown = true;
    } else if (maxQtyText === 'dChain50' || maxQtyText === 'dChain30') {
      var currentPopupElDchaintMaxQtyBO = $('#ph-qo-prod-' + prodCode).find('.ph-dChainMaxQuantityMsg');

      currentPopupElDchaintMaxQtyBO.removeClass('hidden');
      currentPopupElDchaintMaxQtyBO.find('.ph-dchain-max-qty-value').text(dChainFirstEntryQty);

      maxErrPopupShown = true;
    }

    isCartBtnDisabled = ($('.ph-not-avail-msg.hidden').length !== $('.ph-not-avail-msg').length) ||
                        ($('.ph-dchain-qo-error').length > 0) ||
                        ($('.ph-not-avail-30-future-instock-msg.hidden').length !== $('.ph-not-avail-30-future-instock-msg').length) ||
                        ($('.ph-not-avail-30-future-lowstock-msg.hidden').length !== $('.ph-not-avail-30-future-lowstock-msg').length) ||
                        ($('.ph-not-avail-50-nostock-msg.hidden').length !== $('.ph-not-avail-50-nostock-msg').length);

    if (isCartBtnDisabled || maxErrPopupShown) {
      if (!isCartBtnDisabled) {
        $('#ph-qo-prod-' + prodCode).find('.ph-quickorders__qtyplaceholder').addClass('ph-qty-nostock');
      }

      $('.ph-quick-order-button').removeClass('ph-orangebutton').addClass('ph-disable-button');
    } else {
      $('#ph-qo-prod-' + prodCode).find('.ph-quickorders__qtyplaceholder').removeClass('ph-qty-nostock');
      $('.ph-quick-order-button').removeClass('ph-disable-button').addClass('ph-orangebutton');
    }
  },
  commonFunctionAfterATPLoad: function(result) {
    var product = result.code,
        $rowEl = $('#ph-qo-prod-' + result.code),
        backordval = 'backorderset',
        backorderonload = $('#no' + backordval).val(),
        backordernostockLen = 0,
        backorderlowstockLen = 0,
        backorderinstockLen = 0,
        popupcheck = 0,
        $backordcount = $rowEl.find('.ph-lowStock-prodQty'),
        enterQty = '',
        maxquantity = result.atpData.maxStockQty,
        lowStockQty = result.atpData.lowStockQty,
        datapop = 'data-popavail',
        $backordpopobj = $rowEl.find(_PE.modules.quickOrder.stockInfoCls),
        existtext = '',
        maxQtyEnabled = $('#ph-maxQtyEnabled').val(),
        isFreeMarketingProduct = result.isFreeMarketingProduct,
        dChainProductToggle = $('.ph-dchain-product-toggle').val(),
        dChainProductValue = result.dchainValue,
        dChainProdValidFrom = result.validFrom,
        dChainFirstEntry = ACC.common.getDChainFirstEntry(result),
        // eslint-disable-next-line no-negated-condition, no-ternary
        dChainFirstEntryDate = dChainFirstEntry !== null ? Object.keys(dChainFirstEntry)[0] : '',
        // eslint-disable-next-line no-negated-condition, no-ternary, compat/compat
        dChainFirstEntryQty = dChainFirstEntry !== null ? parseInt(Object.values(dChainFirstEntry)[0], 0) : '',
        nobackorderprod = backorderonload;

    /* PHI.common.productATPDataList.push(result); */

    $rowEl.find('.ph-atp-msg-list .ph-orange-msg').addClass('hidden');
    $backordpopobj.attr(datapop, 'green');
    enterQty = _PE.modules.quickOrder.findMaxorderedQuantity($rowEl);
    /* Not used anywhere
    $('#ph-isimportExcel').val(false);
    */

    if (result.atpData.availabilityCode === 'red') {
      $rowEl.find('ph-atp-msg-list').css('display', 'inherit');
      $rowEl.find('.ph-not-avail-msg').removeClass('hidden');
      $backordpopobj.attr(datapop, 'red');
    } else if (result.atpData.availabilityCode === 'orange') {
      $rowEl.find('ph-atp-msg-list').css('display', 'inherit');
      $rowEl.find('.ph-availCount').html(result.atpData.lowStockQty);
      $rowEl.find('.ph-leftover-avail-msg').removeClass('hidden');
      $backordpopobj.attr(datapop, 'orange');
    }

    $rowEl.find('.ph-quickorder__quantity').attr('data-availstatus', result.atpData.availabilityCode);

    if (backorderonload === 'true' && maxQtyEnabled === 'false') {
      $rowEl.find('.ph-quickorder__quantity').attr('data-maxavailqty', maxquantity).attr('data-availstatus', result.atpData.availabilityCode);
      existtext = $backordcount.html();
      $backordcount.text(existtext.replace(' 0 ', ' ' + maxquantity + ' '));
      backordernostockLen = $rowEl.find('.ph-quickorder__quantity[data-availstatus=\'red\']').length;
      backorderlowstockLen = $rowEl.find('.ph-quickorder__quantity[data-availstatus=\'green\']').length;
      backorderinstockLen = $rowEl.find('.ph-quickorder__quantity[data-availstatus=\'orange\']').length;
      /* C
      PE.modules.quickOrder.backorderResponse(backordernostockLen);
      popupcheck = _PE.modules.quickOrder.backorderqtymaxcheck(enterQty, maxquantity, backorderinstockLen, backorderlowstockLen);

      _PE.modules.quickOrder.enableDisableMaxqtyPopup($backordpopobj, popupcheck, result.atpData.availabilityCode);

      if ($('.ph-not-avail-msg:visible').length > 0) {
        $('.ph-quick-order-button').removeClass('ph-orangebutton').addClass('ph-disable-button');
      }
        */
    }

    /* Dchain implementation start */

    if (dChainProductToggle === 'true' && dChainProductValue !== '' && dChainProductValue !== null) {
      if (dChainProductValue === '30') {
        if ((nobackorderprod === 'false' &&
          ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate)) ||
          ((nobackorderprod === 'true') &&
          (result.atpData.availabilityCode === 'green' || result.atpData.availabilityCode === 'orange') &&
          ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))
        ) {
          $('.ph-quick-order-button').addClass('ph-orangebutton').removeClass('ph-disable-button');
        } else if ((nobackorderprod === 'true' && result.atpData.availabilityCode === 'red') ||
          !(ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))
        ) {
          $('.ph-quick-order-button').removeClass('ph-orangebutton').addClass('ph-disable-button');
          $rowEl.find('.ph-atp-msg-list').append('<div class="ph-dchain-qo-error hidden"></div>');

          if ((result.atpData.availabilityCode === 'green' || result.atpData.availabilityCode === 'orange') &&
            !(ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))) {
            $rowEl.find('.ph-atp-msg-list > div').addClass('hidden');

            if (result.atpData.availabilityCode === 'green') {
              $rowEl.find('ph-atp-msg-list').css('display', 'inherit');
              $rowEl.find('.ph-not-avail-30-future-instock-msg').removeClass('hidden');
            } else if (result.atpData.availabilityCode === 'orange') {
              $rowEl.find('ph-atp-msg-list').css('display', 'inherit');
              $rowEl.find('.ph-not-avail-30-future-lowstock-msg').removeClass('hidden');
            }
          }
        }
      } else if (dChainProductValue === '50') {
        // eslint-disable-next-line max-len
        if ((result.atpData.availabilityCode === 'red') || (!ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate) && (dChainFirstEntryQty === '' || dChainFirstEntryQty <= 0))) {
          $rowEl.find('.ph-atp-msg-list > div').addClass('hidden');
          $rowEl.find('ph-atp-msg-list').css('display', 'inherit');
          $rowEl.find('.ph-not-avail-50-nostock-msg').removeClass('hidden');
          $rowEl.find('.ph-atp-msg-list').append('<div class="ph-dchain-qo-error hidden"></div>');
          $('.ph-quick-order-button').removeClass('ph-orangebutton').addClass('ph-disable-button');
        }
      }
    }

    /* Dchain implementation end */

    _PE.modules.quickOrder.checkAndDisplayAllMaxQtyErrorPopup($('#ph-qo-prod-' + product));

    if (maxQtyEnabled === 'true' || isFreeMarketingProduct) {
      var $productElements = $('#quickOrderForm > div[id^="ph-qo-prod-"]'),
          codes = product;

      $productElements.each(function() {
        var currentCode = $(this).attr('id').match(/\d+$/)[0];

        if (currentCode !== product) {
          codes = codes + (',' + currentCode);
        }

        if (backorderonload === 'true') {
          if ($('.ph-not-avail-msg:visible').length > 0) {
            $('.ph-quick-order-button').removeClass('ph-orangebutton').addClass('ph-disable-button');
          }
        }
      });

      if (codes) {
        PHI.common.getMaxQuantity(codes, function(maxQtyResult) {
          var unavailableProducts = _PE.modules.quickOrder.getUnavailableProducts(maxQtyResult),
              phDisableBtnClass = 'ph-disable-button';

          _PE.modules.quickOrder.addEventOnProductWithError(maxQtyResult);

          if (maxQtyResult.productMaxQtyDatas.length === 0) {
            $('.ph-quick-order-button').addClass(phDisableBtnClass);
          }

          if (_PE.modules.quickOrder.getMaxQtyObjByCode(unavailableProducts, product).length >= 1) {
            $('.ph-quick-order-button').addClass(phDisableBtnClass);
            $('#ph-qo-prod-' + product).find('.ph-annualMaxQtyMsg').removeClass('hidden');
            $('#ph-qo-prod-' + product).find('.ph-quickorders__qtyplaceholder').addClass('ph-qty-nostock');
          } else if ($('[id^="ph-qo-prod-"]').length >= 1) {
            $('.ph-quick-order-button').removeClass(phDisableBtnClass);
            $('.ph-quick-order-button').addClass('ph-orangebutton');
          } else if ($('[id^="ph-qo-prod-"]').length >= 1 && $('.ph-prodstock-avail:visible').length > 0) {
            // Remove red style for field
            $('');
          }

          if ($('.ph-prodstock-avail:visible').length > 0) {
            $('.ph-quick-order-button').addClass(phDisableBtnClass);
          }

          _PE.modules.quickOrder.checkAndDisplayAllMaxQtyErrorPopup($('#ph-qo-prod-' + product));
        });
      }
    }
  },
  loadQuickOrderProductAvailability: function(prodCodes) {
    _PE.modules.quickOrder.count = 0;

    for (var i = 0; i < prodCodes.length; i++) {
      _PE.modules.quickOrder.loadSelectedProductAvailability(prodCodes[i]);
    }
  },
  backorderqtymaxcheck: function(enteredQty, backordmaxQty, instockLencheck, lowstockLencheck) {
    var popupdisplay = 0;

    if (enteredQty > backordmaxQty && instockLencheck > 0) {
      popupdisplay = 1;
      _PE.modules.quickOrder.backorderResponse(instockLencheck);

      return popupdisplay;
    }

    if (enteredQty > backordmaxQty && lowstockLencheck > 0) {
      popupdisplay = 1;
      _PE.modules.quickOrder.backorderResponse(lowstockLencheck);

      return popupdisplay;
    }

    return popupdisplay;
  },
  enableDisableMaxqtyPopup: function(popupObj, popupcheck, availStatus) {
    var quickorderqtyplace = 'quickorders__qtyplaceholder';

    if (popupcheck === 1) {
      popupObj.removeClass('hidden');
      popupObj.parents(_PE.modules.quickOrder.quickorderRowCls).find('.ph-' + quickorderqtyplace).addClass('ph-qty-nostock');
    }

    if (popupcheck === 0) {
      popupObj.addClass('hidden');
      popupObj.parents(_PE.modules.quickOrder.quickorderRowCls).find('.ph-' + quickorderqtyplace).removeClass('ph-qty-nostock');
    }

    _PE.modules.quickOrder.enableDisableCartButton(availStatus);
  },
  backorderResponse: function(backordnostockLen) {
    var orengebut = 'ph-orangebutton',
        disbutton = 'ph-disable-button',
        quickbutton = '.ph-quick-order-button';

    if (backordnostockLen > 0) {
      $(quickbutton).removeClass(orengebut).addClass(disbutton);
    } else if ($('.ph-sap-orderBlock').length === 0 && $('.ph-maxQuantityMsg:visible').length === 0) {
      $(quickbutton).removeClass(disbutton).addClass(orengebut);
    } else {
      $(quickbutton).removeClass(orengebut).addClass(disbutton);
    }

    if ($('.ph-disablebutton').length > 0 || $('.ph-interstitial-loader:visible').length > 0) {
      $(quickbutton).removeClass(orengebut).addClass(disbutton);
    }

    ACC.quickOrder.zoomMixCartButtonDisable();
  },
  findMaxorderedQuantity: function($qoRowEl) {
    var maxQuantity = 0;

    $($qoRowEl).each(function() {
      var qtyVal = $(this).find('.ph-quickorder__quantity').val();

      if (parseInt(maxQuantity, 10) < parseInt(qtyVal, 10)) {
        maxQuantity = qtyVal;
      }
    });

    return maxQuantity;
  },
  checkForQuantityField: function(prodCode, prodObject) {
    if (prodCode === '' || prodCode <= 0) {
      ACC.quickOrder.qtyFailed(prodObject, 'emptyqty');
    } else if (isNaN(prodCode)) {
      ACC.quickOrder.qtyFailed(prodObject, 'notNumber');
    } else {
      ACC.quickOrder.productSuccess(prodObject);
    }
  },
  parseActualResponse: function(response) {
    var isError = false;
    var message = '';

    if (response) {
      var tokens = response.split(',');

      if (tokens.length > 0 && tokens[0] === 'false') {
        message = tokens[1];
        isError = true;
      }
    }

    return {
      isError: isError,
      message: message
    };
  },

  loadPriceAndAvailability: function() {
    var prodCodes = [],
        prodcodesIndex = [],
        isPricingCallEnabled = $('.ph-enablepricingcall').length > 0,
        isAtpAvailable = $('.ph-atp-enabled').length > 0,
        $qoForm = $('#quickOrderForm'),
        self = this;

    this.showQuickOrderTitle($qoForm, isAtpAvailable);
    $qoForm.find('.product-hidden-code').each(function() {
      var prodCode = $(this).attr('data-12nc'),
          prodCodeind = $(this).parent().parent().attr('data-rowid');

      if (prodCode) {
        var response = self.parseActualResponse($(this).attr('data-response'));

        var $rowEl = $(this).parent().parent();

        if (response.isError === true) {
          self.hideDataonSelectedRow($rowEl);
          $rowEl.find('.ph-invalid-resp-messg').removeClass('hidden');
        } else {
          $rowEl.find('.ph-invalid-resp-messg').addClass('hidden');
          self.showDataonSelectedRow($rowEl, isAtpAvailable);
          prodCodes.push(prodCode);
          prodcodesIndex.push(prodCodeind);
        }
      }
    });

    if (prodCodes.length > 0) {
      if (isPricingCallEnabled === true) {
        /* ATP call is called after price data is loaded */
        this.loadQuickOrderProductPrice(prodCodes);
      }

      if (isPricingCallEnabled === false && isAtpAvailable === true) {
        /* Loading ATP data directly when pricing in disabled */
        this.loadQuickOrderProductAvailability(prodCodes);
      }
    }
  },

  enableDisableCartButton: function(availstatus) {
    var count = 0,
        backordset = 'nobackorderset',
        backorder = $('#' + backordset).val(),
        qtyElm = 'order__quantity',
        ordForm = 'OrderForm',
        isImportExcel = '#ph-isimportExcel',
        isInvalidVisible = '.ph-invalid-resp-messg:visible',
        nostockLen = $('.ph-quick' + qtyElm + '[data-availstatus=\'red\']').length;

    $('#quick' + ordForm).find('.product-hidden-code').each(function() {
      var productCode = $(this).attr('data-12nc');

      if (productCode) {
        count++;
      }
    });

    if (backorder === 'true' && count > 0) {
      _PE.modules.quickOrder.invalidRespMsgVisibleCheck(isInvalidVisible, nostockLen);

      if ($(isImportExcel).val() === 'true') {
        ACC.quickOrder.enableDisableButton($(ACC.quickOrder.qualityQuickOrd), availstatus);
      }
    } else if (backorder === 'true' && count === 0) {
      _PE.modules.quickOrder.backorderResponse(1);
    }

    if (backorder === 'false' && count > 0) {
      _PE.modules.quickOrder.invalidPopUpMsgVisibleCheck(isInvalidVisible);

      if ($(isImportExcel).val() === 'true') {
        ACC.quickOrder.enableDisableButton($(ACC.quickOrder.qualityQuickOrd), availstatus);
      }
    } else if (backorder === 'false' && count === 0) {
      _PE.modules.quickOrder.backorderResponse(1);
    }

    ACC.quickOrder.zoomMixCartButtonDisable();
  },
  invalidRespMsgVisibleCheck: function(isInvalidVisible, nostockLen) {
    if ($(isInvalidVisible).length > 0) {
      _PE.modules.quickOrder.backorderpopLenVisibleCheck(1);
    } else {
      _PE.modules.quickOrder.backorderpopLenVisibleCheck(nostockLen);
    }
  },
  invalidPopUpMsgVisibleCheck: function(isInvalidVisible) {
    if ($(isInvalidVisible).length > 0) {
      _PE.modules.quickOrder.backorderResponse(1);
    } else {
      _PE.modules.quickOrder.backorderResponse(0);
    }
  },
  backorderpopLenVisibleCheck: function(nostockLen) {
    var popvisibleLenth = $('.ph-stockinfo:visible').length;

    if (popvisibleLenth > 0 || nostockLen > 0) {
      _PE.modules.quickOrder.backorderResponse(1);
    }

    if (popvisibleLenth === 0 && nostockLen === 0) {
      _PE.modules.quickOrder.backorderResponse(0);
    }
  },
  /* eslint-disable max-params */
  getQuickOrderResponse: function(prodCode, qty, index, successCallback, failureCallback) {
    var apiUrl = ACC.config.encodedContextPath + '/quickOrder/quickOrderResponse';

    /* eslint-enable max-params */
    $.ajax({
      type: 'POST',
      url: apiUrl,
      dataType: 'json',
      data: {
        code: prodCode,
        qty: qty,
        index: index
      },
      success: function(data) {
        successCallback(data);
      },
      error: function(error) {
        if (failureCallback) {
          failureCallback(error);
        }
      },
      complete: function() {
        self.enableDisableCartButton('');
      }
    });
  },
  priceDataInitialize: function($rowEl, priceDataResult) {
    var productData = priceDataResult,
        priceList = productData.priceList,
        $isPromotionEnabled = $('.ph-promotionenabled'),
        isFreeMarkettingProduct = productData.isFreeMarketingProduct,
        loaderIcon = 'quick-loader';

    _PE.modules.quickOrder.setFreeMarketingProduct(productData.code, isFreeMarkettingProduct);

    for (var priceIndex = 0; priceIndex < priceList.length; priceIndex = priceIndex + 1) {
      var priceRow = priceList[priceIndex];

      if (priceRow.priceType === 'FROM' && $isPromotionEnabled.length > 0) {
        var priceContent = '<span class="ph-strike-price">' + priceRow.formattedValue + '</span>';

        $rowEl.find('#' + priceRow.pricingConditionCode).html(priceContent);
      } else if (priceRow.priceType === 'BUY' && priceRow.pricingConditionCode !== 'YLRR') {
        $rowEl.find('#' + priceRow.pricingConditionCode).html(priceRow.formattedValue);
      }

      $rowEl.find('.ph-' + loaderIcon).addClass('hidden');
    }
  },
  loadSelectedProductPrice: function($rowEl, product) {
    var prodCodes = [product];

    PHI.common.getPriceData(prodCodes, function(result) {
      var isAtpAvailable = $('.ph-atp-enabled').length > 0;

      if (Array.isArray(result) && result.length === 1) {
        _PE.modules.quickOrder.priceDataInitialize($rowEl, result[0]);
      }

      if (isAtpAvailable === true) {
        _PE.modules.quickOrder.loadSelectedProductAvailability(product);
      }
    // eslint-disable-next-line no-undefined
    }, undefined, function() {
      $rowEl.find('.ph-quick-loader').addClass('hidden');
    });
  },

  loadSelectedProductAvailability: function(product) {
    PHI.common.getAtpData(product, function(result) {
      _PE.modules.quickOrder.commonFunctionAfterATPLoad(result);
    });
  },

  hideDataonSelectedRow: function($rowEl) {
    $rowEl.find('.ph-replace-prodlabel .ph-replable').removeClass('hidden');
    $rowEl.find('.ph-prod-url').html('');
    $rowEl.find('.ph-pritemlists').html('');
    $rowEl.find('.ph-not-avail-msg').addClass('hidden');
    $rowEl.find('.ph-leftover-avail-msg').addClass('hidden');
    $rowEl.find('.product_quantity').val('');
  },

  showDataonSelectedRow: function($rowEl, isAtpAvailable) {
    if (isAtpAvailable === true) {
      $rowEl.find('.avail').css('display', 'inline-block');
    }
  },

  loadSelectedProductData: function($rowEl, data) {
    $rowEl.attr('id', 'ph-qo-prod-' + data.code);
    $rowEl.attr('data-ctn', data.ctv);
    $rowEl.attr('data-list-name', 'quick-order');

    var listPosition = $rowEl.find('.product_id').attr('tabindex');

    $rowEl.attr('data-list-position', listPosition);
    $rowEl.attr('data-track-productcard-visibility', '');

    var productElem = '<a href="' + ACC.config.encodedContextPath + data.url + '">' + data.ctv + ' ' + data.displayName + '</a>';

    $rowEl.find('.ph-prod-url').html(productElem);
    $rowEl.find('.ph-replace-prodlabel .ph-replable').addClass('hidden');

    var isPricingCallEnabled = $('.ph-enablepricingcall').length > 0;
    var isAtpAvailable = $('.ph-atp-enabled').length > 0;

    if (isPricingCallEnabled === true) {
      /* ATP call is called after price data is loaded */
      $rowEl.find('.ph-quick-loader').removeClass('hidden');

      this.loadQuickOrderProductPrice([data.code]);
      // Commenting this.loadSelectedProductPrice( data.code);
    }

    if (isPricingCallEnabled === false && isAtpAvailable === true) {
      /* Loading ATP data directly when pricing in disabled */
      this.loadSelectedProductAvailability(data.code);
    }
  },

  handleQuickOrderResponse: function(data, $rowEl) {
    var response = this.parseActualResponse(data.response),
        hiddenCode = data.productEntered,
        ctv = data.ctv,
        errorMsg = '',
        isBlocked = '',
        respMessage = 'ph-invalid-resp-messg',
        $hiddenProductCode = $('#product_hidden_code-' + $rowEl.find('.product-code').attr('tabIndex'));

    $hiddenProductCode.attr('data-ctv', ctv);
    $hiddenProductCode.attr('data-12nc', data.code);
    $hiddenProductCode.attr('iszoomdelivered', data.zoomDelivered);
    $hiddenProductCode.val(hiddenCode);

    $rowEl.find(_PE.modules.quickOrder.prodqty).val(data.quantity);
    isBlocked = ACC.common.isBlockedProduct(data.code);

    if (isBlocked === true) {
      errorMsg = $('.ph-blockedprd-msg').text();
    } else {
      errorMsg = response.message;
    }

    if (response.isError === false) {
      this.enableDisableCartButton('');
      this.loadSelectedProductData($rowEl, data);
    } else {
      this.hideDataonSelectedRow($rowEl);

      if (errorMsg === '') {
        $rowEl.find('.' + respMessage).addClass('hidden');
      } else {
        $rowEl.find('.' + respMessage).text(errorMsg).removeClass('hidden');
        ACC.quickOrder.disableButtonIfErrorsExist(true);
      }
    }
  },

  countRows: function(eve) {
    eve.preventDefault();

    var count = $('#quickOrders').find('[id^=ph-qo-prod-]').length,
        qbtn = '-order-button',
        didtn = '-disable-button';

    $('#quickorder-rowcount').attr('value', count);

    if (count > 0 && ACC.common.showMixedCartCheck($('.quick-order-button')) === true) {
      ACC.common.showzoomDeliveredPopUp('quickorder');
      $('.ph-quick' + qbtn).addClass('ph' + didtn);
    } else if (count > 0) {
      $('#quickOrderForm')[0].submit();
      $('.ph-quick' + qbtn).addClass('ph' + didtn);
    }
  },

  addARow: function() {
    var formId = '.quickorder',
        lastItemcheck = '',
        dummy = $(formId).find('.ph-quickorders__rows.dummy'),
        rows = $(formId).find('.ph-quickorders__rows:not(.dummy)'),
        lastItemRow = 'ph-quickorders__rows:not(.dummy):last',
        hiddenProduct = '<input type="hidden" class="product-hidden-code" type="text" name="product_hidden_code" id="product_hidden_code" value="">';

    var self = this;

    if ($(formId).find('.' + lastItemRow).length === 0) {
      lastItemcheck = $(formId).find('#ph-quicklist');
    } else {
      lastItemcheck = $(formId).find('.' + lastItemRow);
    }

    dummy.clone().insertAfter(lastItemcheck)
      .removeClass('dummy').removeClass('ph-d-none').addClass('ph-d-flex').find('input.product-code').attr('tabindex', rows.length + self.deletedRows)
      .attr('name', 'product_code-' + (rows.length + self.deletedRows) / 1)
      .attr('id', 'product_code-' + (rows.length + self.deletedRows) / 1)
      .attr('data-autolistinput', (rows.length + self.deletedRows) / 1)
      .after(hiddenProduct);

    $(formId).find('.' + lastItemRow)
      .find('input.product-hidden-code').attr('tabindex', rows.length + self.deletedRows)
      .attr('name', 'product_hidden_code-' + (rows.length + self.deletedRows) / 1)
      .attr('id', 'product_hidden_code-' + (rows.length + self.deletedRows) / 1);

    $(formId).find('.' + lastItemRow).find('.ph-quicklist')
      .attr('id', 'ph-autosearchlist-' + (rows.length + self.deletedRows) / 1);

    $(formId).find('.' + lastItemRow)
      .find('input.product-quantity').attr('tabindex', rows.length + self.deletedRows)
      .attr('name', 'product_quantity-' + (rows.length + self.deletedRows) / 1)
      .attr('id', 'product_quantity-' + (rows.length + self.deletedRows) / 1);

    var trashbon = 'img-trashbin';
    var deleteBtn = $(formId).find('.ph-' + trashbon);

    /* eslint-enable no-mixed-operators */

    deleteBtn.off('click');
    deleteBtn.click(function() {
      var quickrow = '.ph-quickorders__',
          backorsetval = 'orderset',
          backorder = $('#noback' + backorsetval).val();


      $(this).closest(quickrow + 'rows').remove();
      ++self.deletedRows;

      if (backorder === 'true') {
        _PE.modules.quickOrder.enableDisableCartButton('');
      }

      /*  Console.log(self.deletedRows);*/
      /* eslint-disable dollar-sign/dollar-sign */
      self.lastItem = $('.' + lastItemRow);
      self.handleLastItem();
    });
    /* eslint-enable dollar-sign/dollar-sign */
    self.lastItem = $(formId).find('.' + lastItemRow);
    self.handleLastItem();
  },
  handleLastItem: function() {
    var self = this,
        prodQtyMg = '.product-quantity';

    $('input' + prodQtyMg).off('focus');
    this.lastItem.find('input' + prodQtyMg).on('focus', function() {
      self.addARow();
      ACC.autocomplete.bindAll();
    });
    this.lastItem.find('input' + prodQtyMg).keydown(function(e) {
      if (e.keyCode === 9 && !e.shiftKey) {
        self.addARow();
        ACC.autocomplete.bindAll();
      }
    });
  }
};

$('#search').click(function(event) {
  event.stopPropagation();
});

/* eslint-disable  no-implicit-globals */
function ScrollPage() {
  window.scrollTo(0, 300);
}

var get_browser_version = navigator.appVersion;

var get_browser_name = navigator.appName;

if (get_browser_name === 'Microsoft Internet Explorer') {
  $('#new_declare .rp-select').css('width', '958px');
  $('#new_declare .rp-select select').css('width', '958px');
  $('#new_declare .rp-select').css('background-position', '958px 13px');
}

function isNumberKey(evt) {
/* eslint-disable  no-ternary */
  var charCode = evt.which ? evt.which : event.keyCode;

  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }

  /* eslint-enable  no-ternary */
  return true;
}

/* eslint-enable  no-implicit-globals */
$('.order-history-detail').find('li').each(function() {
  var $this = $(this);

  $this.html($this.html().replace(/&nbsp;/g, ''));
});

/* eslint-disable no-implicit-globals */
// Var get_menu_length      = $("ul.level-2").children().length;
var get_menu_length = $('.level-1 ul.level-2').children('li').length,
    get_language_string = $('#ph-encodedcontext_path').val(),
    break_string = get_language_string.split('/');
/* eslint-enable no-implicit-globals */


if (get_menu_length === '6') {
  $('.cat_name_line').css('height', '24px');
  /* eslint-disable  sonarjs/no-duplicated-branches */
  $('.navigation li .level-2 a').addClass('transformed-menu');
} else if (break_string[3] === 'es' && get_menu_length >= '5') {
  /* eslint-enable  sonarjs/no-duplicated-branches */
  $('.cat_name_line').css('height', '24px');
  $('.navigation li .level-2 a').addClass('transformed-menu');
}

$('.faq_icon').hover(function() {
  $('.faq_icon').addClass('faq_icon_white');
});

$('.faq_icon').mouseout(function() {
  $('.faq_icon').removeClass('faq_icon_white');
});

$(document).ready(function() {
  $(document).on('click', '.ph-img-trashbin', function() {
    var row = $(this).closest(_PE.modules.quickOrder.quickorderRowCls),
        index = $(row).find('.ph-quickorders__productvalue').attr('tabindex');

    var removeQuickOrderEntry = function(remindex) {
      var url = ACC.config.encodedContextPath + '/quickOrder/removeEntry';

      $.ajax({
        type: 'POST',
        url: url,
        data: {
          index: remindex
        },
        success: function() {
          _PE.modules.quickOrder.enableDisableCartButton('');
        }
      });
    };

    /* eslint-enable no-invalid-this */
    removeQuickOrderEntry(index);
    $(row).remove();
    ++self.deletedRows;
  });
});
$(document).ready(function() {
  function errorCountRows() {
    var productLoop = '',
        i = 0,
        count = 0,
        quickord = 'quickOrder',
        disbtn = 'disable-button',
        ordbtn = 'order-button';

    productLoop = $('.product-code');
    productLoop.each(function() {
      if (productLoop[i].value !== '') {
        count = count + 1;
      }

      i = i + 1;
    });

    $('#quickorder-rowcount').attr('value', count);

    if (count > 0 && ACC.common.showMixedCartCheck($('.quick-order-button')) === true) {
      ACC.common.showzoomDeliveredPopUp('quickorder');
      $('.ph-quick-' + ordbtn).addClass('ph-' + disbtn);
    } else if (count > 0) {
      $('#' + quickord + 'Form')[0].submit();
      $('.ph-quick-' + ordbtn).addClass('ph-' + disbtn);
    }
  }

  if ($('.negative').length > 0) {
    $(document).on('click', '.ph-quickOrder-excel', function() {
      var togglequickEx = '.ph-togglequick-first',
          quickOrderEx = '.ph-quickOrder-importExcel';

      $(togglequickEx).addClass('hidden');
      $(quickOrderEx).removeClass('hidden');
    });

    $(document).on('click', '.ph-quickOrder-addProduct-manual', function() {
      var togglequickMa = '.ph-togglequick-first',
          quickOrderMa = '.ph-quickOrder-importExcel';

      $(togglequickMa).removeClass('hidden');
      $(quickOrderMa).addClass('hidden');
    });

    $(document).on('click', '.ph-togglequick .ph-quickOrder-excel-btn-import', function() {
      var file = '#fileImport';

      $(file).click();
    });

    $('.quick-order-button').removeClass('ph-disable-button');
    /* Commenting to avoid duplicate calls
    _PE.modules.quickOrder.loadPriceAndAvailability();
    _PE.modules.quickOrder.enableDisableCartButton('');
    */

    $('.quickorder-rowcount').click(function() {
      errorCountRows();

      if ($('.ph-disable-button').length > 0) {
        return false;
      }

      return true;
    });
    $('.addRow').click(function() {
      _PE.modules.quickOrder.addARow();
    });
    $('#importOrderForm #fileImport').bind('input', function() {
      $('.uploadBtn').submit();
    });

    $('.ph-quickorders__clearall').click(function() {
      $.ajax({
        url: ACC.config.encodedContextPath + '/quickOrder/removeAllEntries',
        type: 'GET',
        datatype: 'json',
        success: function() {
          window.location.replace(ACC.config.encodedContextPath + '/quickOrder');
        }
      });
    });
    /* eslint-disable no-invalid-this*/
    $(document).on('change', '.ph-quickorders__productvalue', function() {
      var impqty = $(this).parent().next().find(_PE.modules.quickOrder.prodqty).val(),
          impindex = $(this).attr('tabindex'),
          impprodCode = $(this).val(),
          impprodinvald = 'invalid-resp-messg',
          impprodrow = 'quickorders__rows';

      if (impprodCode !== '') {
        var $rowEl = $(this).parents('.ph-' + impprodrow);

        $rowEl.find('.ph-' + impprodinvald).addClass('hidden');

        _PE.modules.quickOrder.getQuickOrderResponse(impprodCode, impqty, impindex, function(result) {
          _PE.modules.quickOrder.handleQuickOrderResponse(result, $rowEl);
        });
        // Adding below 2 lines from the duplicated event
        $rowEl.find('.ph-quickorders__qtyplaceholder').removeClass('ph-invalidproductdiv');
        $rowEl.find('.ph-prodqtyinvalid').removeClass('ph-wrongprod');
      }
    });
  }
});
$(document).ready(function() {
  if ($('.negative').length > 0) {
    $(document).on('keyup', '.product_quantity', function() {
      var impbackorder = $('#nobackorderset').val();

      if (impbackorder === 'true') {
        var imparentrow = '.ph-quickorders__',
            imquantityvar = 'h-quickorder__quantity',
            $rowEl = $(this).parents(imparentrow + 'rows'),
            $imbackordpopobj = $rowEl.find(_PE.modules.quickOrder.stockInfoCls),
            maxqy = 'maxavailqty',
            immaxstockVal = parseInt($rowEl.find('.p' + imquantityvar).attr('data-' + maxqy), 10),
            imenteredVal = $(this).val(),
            qtyErrorVisible = $rowEl.find('.ph-qtyerrmsg-parent:visible'),
            availStats = 'availstatus';

        if (imenteredVal > immaxstockVal && $(this).attr('data-' + availStats) !== 'red' && qtyErrorVisible.length === 0) {
          _PE.modules.quickOrder.enableDisableMaxqtyPopup($imbackordpopobj, 1, $(this).attr('data-' + availStats));
        } else {
          _PE.modules.quickOrder.enableDisableMaxqtyPopup($imbackordpopobj, 0, $(this).attr('data-' + availStats));
        }

        _PE.modules.quickOrder.enableDisableCartButton($(this).attr('data-' + availStats));
      }
    });
    $(document).on('blur', '.ph-quickorder__quantity', function() {
      var $row = $(this).closest(_PE.modules.quickOrder.quickorderRowCls),
          prodCode = $(this).val(),
          prodObject = {
            $productParent: ''
          },
          quickorderqtyplace = 'quickorders__qtyplaceholder';

      prodObject.$productParent = $row.find('.ph-' + quickorderqtyplace);
      prodObject.$errorField = $row.find(ACC.quickOrder.quantityInvalidCls);
      $row.find('.ph-importinvalidqty').css('display', 'none');
      $(this).removeClass('ph-qtyerror-import');
      $('.ph-product-code-label').removeClass('ph-qtylabel-import');

      _PE.modules.quickOrder.checkForQuantityField(prodCode, prodObject);
      ACC.quickOrder.enableDisableButton($(this));
    });
  }
});
/* eslint-enable no-invalid-this*/
/* eslint-enable no-plusplus */
/* eslint-enable consistent-this*/
/* eslint-enable vars-on-top*/
/* eslint-enable id-match*/
/* eslint-enable id-length*/
/* eslint-enable camelcase*/
/* eslint-enable no-unused-vars*/
/* eslint-enable xss/no-mixed-html*/
/* eslint-enable max-lines*/
/* eslint-enable max-statements*/
/* eslint-enable complexity*/
